export const posts = [
  {
    "slug": "draft-wrong-city-2023-01-02",
    "title": "Do not publish a draft that names the wrong city, January 2, 2023",
    "seoTitle": "Wrong city in drafted copy (contractor, January 2, 2023)",
    "description": "Wrong city in drafted copy for a contractor on January 2, 2023. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2023-01-02",
    "cta": "This week, look at the cities in a draft. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A draft will invent a service area. Delete any city you do not drive to before the page goes up.",
          "This January 2, 2023 note is for a contractor. The check is wrong city in drafted copy: the cities in a draft, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the cities in a draft",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the cities in a draft. In January 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The cities in a draft on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the cities in a draft before you add anything",
        "paragraphs": [
          "A mismatch on wrong city in drafted copy is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare the cities in a draft. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "A writing tool still needs your facts, November 28, 2022",
        "href": "/blog/drafts-need-your-facts-2022-2022-11-28"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "one-january-offer-2023-01-09",
    "title": "Keep the January offer to a single line, January 9, 2023",
    "seoTitle": "January promotion (salon, January 9, 2023)",
    "description": "January promotion for a salon on January 9, 2023. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2023-01-09",
    "cta": "This week, look at one current offer. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "One sentence about a slow-month opening is useful. A stack of banners is how the phone number gets pushed below the fold.",
          "This January 9, 2023 note is for a salon. The check is January promotion: one current offer, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at one current offer",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at one current offer. In January 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "One current offer on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix one current offer before you add anything",
        "paragraphs": [
          "A mismatch on January promotion is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare one current offer. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Describe the fall maintenance visit in a few lines, October 17, 2022",
        "href": "/blog/fall-maintenance-2022-10-17"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "form-after-the-break-2023-01-16",
    "title": "Send a test message after the break, January 16, 2023",
    "seoTitle": "Contact form test (clinic, January 16, 2023)",
    "description": "Contact form test for a clinic on January 16, 2023. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2023-01-16",
    "cta": "This week, look at a test message from the form. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Send one message to yourself. If it lands in spam, or nowhere, the form is not a way to reach you.",
          "This January 16, 2023 note is for a clinic. The check is contact form test: a test message from the form, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a test message from the form",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a test message from the form. In January 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A test message from the form on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a test message from the form before you add anything",
        "paragraphs": [
          "A mismatch on contact form test is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare a test message from the form. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "first-week-phone-test-2023-01-23",
    "title": "Call the listing number in the first week back, January 23, 2023",
    "seoTitle": "Listing phone number (restaurant, January 23, 2023)",
    "description": "Listing phone number for a restaurant on January 23, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-01-23",
    "cta": "This week, look at the number on the listing. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Tap the number on the listing from a phone that is not on shop Wi-Fi. It has to ring the person who is actually there.",
          "This January 23, 2023 note is for a restaurant. The check is listing phone number: the number on the listing, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the number on the listing",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the number on the listing. In January 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The number on the listing on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the number on the listing before you add anything",
        "paragraphs": [
          "A mismatch on listing phone number is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare the number on the listing. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set New Year hours before the week starts, December 26, 2022",
        "href": "/blog/new-year-hours-2023-2022-12-26"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "read-the-draft-aloud-2023-01-30",
    "title": "Read a drafted page out loud at the desk, January 30, 2023",
    "seoTitle": "Reading drafted website copy (law office, January 30, 2023)",
    "description": "Reading drafted website copy for a law office on January 30, 2023. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2023-01-30",
    "cta": "This week, look at a draft read out loud. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If the person at the desk would not say the sentence, it does not belong on the site.",
          "This January 30, 2023 note is for a law office. The check is reading drafted website copy: a draft read out loud, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a draft read out loud",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a draft read out loud. In January 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A draft read out loud on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a draft read out loud before you add anything",
        "paragraphs": [
          "A mismatch on reading drafted website copy is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare a draft read out loud. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Do not publish a draft that names the wrong city, January 2, 2023",
        "href": "/blog/draft-wrong-city-2023-01-02"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "rain-delay-note-2023-02-06",
    "title": "Explain a rain delay before people drive over, February 6, 2023",
    "seoTitle": "Rain delay notice (retail shop, February 6, 2023)",
    "description": "Rain delay notice for a retail shop on February 6, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-02-06",
    "cta": "This week, look at how you handle a rain day. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Outdoor work slips in a wet week. A listing post that says you will call to reschedule beats a locked door.",
          "This February 6, 2023 note is for a retail shop. The check is rain delay notice: how you handle a rain day, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at how you handle a rain day",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at how you handle a rain day. In February 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "How you handle a rain day on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix how you handle a rain day before you add anything",
        "paragraphs": [
          "A mismatch on rain delay notice is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare how you handle a rain day. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Call the listing number in the first week back, January 23, 2023",
        "href": "/blog/first-week-phone-test-2023-01-23"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "valentine-hours-2023-2023-02-13",
    "title": "Put Valentine's week hours and the offer in one place, February 13, 2023",
    "seoTitle": "Valentine's week hours (contractor, February 13, 2023)",
    "description": "Valentine's week hours for a contractor on February 13, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-02-13",
    "cta": "This week, look at Valentine's week. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If 2023 includes a Valentine offer or a fuller book, say the hours and the last day of the offer. Leave the business name alone.",
          "This February 13, 2023 note is for a contractor. The check is Valentine's week hours: Valentine's week, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Valentine's week",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Valentine's week. In February 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Valentine's week on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Valentine's week before you add anything",
        "paragraphs": [
          "A mismatch on Valentine's week hours is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare Valentine's week. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Explain a rain delay before people drive over, February 6, 2023",
        "href": "/blog/rain-delay-note-2023-02-06"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "february-reminders-2023-02-20",
    "title": "Check reminders for the right month, February 20, 2023",
    "seoTitle": "Appointment reminders (salon, February 20, 2023)",
    "description": "Appointment reminders for a salon on February 20, 2023. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2023-02-20",
    "cta": "This week, look at the month named in reminders. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A reminder that still says January, or sends people to last year's address, undoes the booking.",
          "This February 20, 2023 note is for a salon. The check is appointment reminders: the month named in reminders, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the month named in reminders",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the month named in reminders. In February 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The month named in reminders on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the month named in reminders before you add anything",
        "paragraphs": [
          "A mismatch on appointment reminders is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare the month named in reminders. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Keep the January offer to a single line, January 9, 2023",
        "href": "/blog/one-january-offer-2023-01-09"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "tool-does-not-know-hours-2023-02-27",
    "title": "A writing tool does not know this week's hours, February 27, 2023",
    "seoTitle": "Hours a writing tool cannot know (clinic, February 27, 2023)",
    "description": "Hours a writing tool cannot know for a clinic on February 27, 2023. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2023-02-27",
    "cta": "This week, look at hours a tool will get wrong. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Type the hours from the door. Do not accept a schedule a tool guessed.",
          "This February 27, 2023 note is for a clinic. The check is hours a writing tool cannot know: hours a tool will get wrong, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at hours a tool will get wrong",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at hours a tool will get wrong. In February 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Hours a tool will get wrong on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix hours a tool will get wrong before you add anything",
        "paragraphs": [
          "A mismatch on hours a writing tool cannot know is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare hours a tool will get wrong. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Read a drafted page out loud at the desk, January 30, 2023",
        "href": "/blog/read-the-draft-aloud-2023-01-30"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "wet-weather-jobs-2023-03-06",
    "title": "Say how wet weather changes the schedule, March 6, 2023",
    "seoTitle": "Wet weather schedule (restaurant, March 6, 2023)",
    "description": "Wet weather schedule for a restaurant on March 6, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-03-06",
    "cta": "This week, look at how rain changes the day. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If rain moves a job, say how you tell the customer. A listing that still says you arrive at nine will be wrong by noon.",
          "This March 6, 2023 note is for a restaurant. The check is wet weather schedule: how rain changes the day, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at how rain changes the day",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at how rain changes the day. In March 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "How rain changes the day on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix how rain changes the day before you add anything",
        "paragraphs": [
          "A mismatch on wet weather schedule is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare how rain changes the day. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Put Valentine's week hours and the offer in one place, February 13, 2023",
        "href": "/blog/valentine-hours-2023-2023-02-13"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "march-price-list-2023-03-13",
    "title": "Update the March price or starting rate, March 13, 2023",
    "seoTitle": "March prices (law office, March 13, 2023)",
    "description": "March prices for a law office on March 13, 2023. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2023-03-13",
    "cta": "This week, look at the rate you quote now. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If the visit has a starting price, publish the one you say on the phone. Last spring's number is a different offer.",
          "This March 13, 2023 note is for a law office. The check is March prices: the rate you quote now, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the rate you quote now",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the rate you quote now. In March 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The rate you quote now on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the rate you quote now before you add anything",
        "paragraphs": [
          "A mismatch on March prices is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare the rate you quote now. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Check reminders for the right month, February 20, 2023",
        "href": "/blog/february-reminders-2023-02-20"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "reviews-as-work-picks-up-2023-03-20",
    "title": "Ask for a review after a finished March job, March 20, 2023",
    "seoTitle": "Asking for a Google review (retail shop, March 20, 2023)",
    "description": "Asking for a Google review, retail shop, March 20, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-03-20",
    "cta": "This week, look at when you ask for a review. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Ask after the work is done, not before. One sentence and the review link is enough for the person at the desk.",
          "This March 20, 2023 note is for a retail shop. The check is asking for a Google review: when you ask for a review, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at when you ask for a review",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at when you ask for a review. In March 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "When you ask for a review on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix when you ask for a review before you add anything",
        "paragraphs": [
          "A mismatch on asking for a Google review is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare when you ask for a review. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Say how wet weather changes the schedule, March 6, 2023",
        "href": "/blog/wet-weather-jobs-2023-03-06"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "written-answers-above-links-2023-03-27",
    "title": "Search is testing short written answers, March 27, 2023",
    "seoTitle": "Written answers in search (contractor, March 27, 2023)",
    "description": "Written answers in search for a contractor on March 27, 2023. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2023-03-27",
    "cta": "This week, look at a short answer above the links. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Late 2022 and 2023, search sometimes showed a written blurb above the links. Your page still needs the phone number, because the blurb will not book the job.",
          "This March 27, 2023 note is for a contractor. The check is written answers in search: a short answer above the links, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a short answer above the links",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a short answer above the links. In March 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A short answer above the links on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a short answer above the links before you add anything",
        "paragraphs": [
          "A mismatch on written answers in search is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare a short answer above the links. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "A writing tool does not know this week's hours, February 27, 2023",
        "href": "/blog/tool-does-not-know-hours-2023-02-27"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "easter-hours-2023-2023-04-03",
    "title": "Write Easter week hours as special hours, April 3, 2023",
    "seoTitle": "Easter week hours (salon, April 3, 2023)",
    "description": "Easter week hours for a salon on April 3, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-04-03",
    "cta": "This week, look at Easter week hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Easter week in 2023 is not a normal week. Mark the day you close, and leave the rest of the weekly schedule as the days you are open.",
          "This April 3, 2023 note is for a salon. The check is Easter week hours: Easter week hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Easter week hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Easter week hours. In April 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Easter week hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Easter week hours before you add anything",
        "paragraphs": [
          "A mismatch on Easter week hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare Easter week hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Ask for a review after a finished March job, March 20, 2023",
        "href": "/blog/reviews-as-work-picks-up-2023-03-20"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "seasonal-work-you-are-booking-2023-04-10",
    "title": "Name the seasonal work you are actually booking, April 10, 2023",
    "seoTitle": "Seasonal work (clinic, April 10, 2023)",
    "description": "Seasonal work for a clinic on April 10, 2023. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2023-04-10",
    "cta": "This week, look at the seasonal job you are taking. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Exterior, events, and busy-season visits need their own sentence. Do not leave them inside a paragraph about something else.",
          "This April 10, 2023 note is for a clinic. The check is seasonal work: the seasonal job you are taking, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the seasonal job you are taking",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the seasonal job you are taking. In April 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The seasonal job you are taking on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the seasonal job you are taking before you add anything",
        "paragraphs": [
          "A mismatch on seasonal work is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare the seasonal job you are taking. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Update the March price or starting rate, March 13, 2023",
        "href": "/blog/march-price-list-2023-03-13"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "longer-daylight-hours-2023-04-17",
    "title": "Lengthen the posted hours only if you stay later, April 17, 2023",
    "seoTitle": "Evening hours (restaurant, April 17, 2023)",
    "description": "Evening hours for a restaurant on April 17, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-04-17",
    "cta": "This week, look at whether you are open later. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Longer days are not longer hours unless the door is actually open. Change the listing only to match the lock.",
          "This April 17, 2023 note is for a restaurant. The check is evening hours: whether you are open later, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at whether you are open later",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at whether you are open later. In April 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Whether you are open later on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix whether you are open later before you add anything",
        "paragraphs": [
          "A mismatch on evening hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare whether you are open later. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write Easter week hours as special hours, April 3, 2023",
        "href": "/blog/easter-hours-2023-2023-04-03"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "blurb-can-be-wrong-2023-04-24",
    "title": "A written answer can have the wrong hours, April 24, 2023",
    "seoTitle": "Incorrect hours in a search answer (law office, April 24, 2023)",
    "description": "Incorrect hours in a search answer for a law office on April 24, 2023. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2023-04-24",
    "cta": "This week, look at hours inside a short answer. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If a blurb says you are open and the door is locked, fix the profile hours. That is the source you control.",
          "This April 24, 2023 note is for a law office. The check is incorrect hours in a search answer: hours inside a short answer, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at hours inside a short answer",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at hours inside a short answer. In April 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Hours inside a short answer on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix hours inside a short answer before you add anything",
        "paragraphs": [
          "A mismatch on incorrect hours in a search answer is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare hours inside a short answer. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Search is testing short written answers, March 27, 2023",
        "href": "/blog/written-answers-above-links-2023-03-27"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "may-outdoor-photos-2023-05-01",
    "title": "Photograph the outside in this month's light, May 1, 2023",
    "seoTitle": "May photos of the business (retail shop, May 1, 2023)",
    "description": "May photos of the business for a retail shop on May 1, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-05-01",
    "cta": "This week, look at a photo taken this month. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Blossoms, a clear sidewalk, or the real truck in the lot. The cover should look like a visit this week.",
          "This May 1, 2023 note is for a retail shop. The check is May photos of the business: a photo taken this month, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a photo taken this month",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a photo taken this month. In May 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A photo taken this month on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a photo taken this month before you add anything",
        "paragraphs": [
          "A mismatch on May photos of the business is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare a photo taken this month. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Lengthen the posted hours only if you stay later, April 17, 2023",
        "href": "/blog/longer-daylight-hours-2023-04-17"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "mother-hours-2023-2023-05-08",
    "title": "Say how Mother's Day bookings work this year, May 8, 2023",
    "seoTitle": "Mother's Day bookings (contractor, May 8, 2023)",
    "description": "Mother's Day bookings for a contractor on May 8, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-05-08",
    "cta": "This week, look at Mother's Day bookings. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The week of Mother's Day in 2023 fills early for a lot of shops. Say whether you are taking reservations, walk-ins, or neither, and the hour you stop.",
          "This May 8, 2023 note is for a contractor. The check is Mother's Day bookings: Mother's Day bookings, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Mother's Day bookings",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Mother's Day bookings. In May 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Mother's Day bookings on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Mother's Day bookings before you add anything",
        "paragraphs": [
          "A mismatch on Mother's Day bookings is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare Mother's Day bookings. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Photograph the outside in this month's light, May 1, 2023",
        "href": "/blog/may-outdoor-photos-2023-05-01"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "school-year-ending-2023-05-15",
    "title": "Adjust hours as school schedules change, May 15, 2023",
    "seoTitle": "End of school year hours (salon, May 15, 2023)",
    "description": "End of school year hours for a salon on May 15, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-05-15",
    "cta": "This week, look at hours as school lets out. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "After-school rushes and earlier dinners show up now. If your busy hours moved, move them on the listing.",
          "This May 15, 2023 note is for a salon. The check is end of school year hours: hours as school lets out, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at hours as school lets out",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at hours as school lets out. In May 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Hours as school lets out on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix hours as school lets out before you add anything",
        "paragraphs": [
          "A mismatch on end of school year hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare hours as school lets out. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Say how Mother's Day bookings work this year, May 8, 2023",
        "href": "/blog/mother-hours-2023-2023-05-08"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "draft-invents-reviews-2023-05-22",
    "title": "Do not let a draft invent reviews, May 22, 2023",
    "seoTitle": "Invented reviews (clinic, May 22, 2023)",
    "description": "Invented reviews for a clinic on May 22, 2023. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2023-05-22",
    "cta": "This week, look at reviews a tool made up. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Quotes on the page have to come from real customers. Delete anything the tool composed.",
          "This May 22, 2023 note is for a clinic. The check is invented reviews: reviews a tool made up, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at reviews a tool made up",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at reviews a tool made up. In May 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Reviews a tool made up on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix reviews a tool made up before you add anything",
        "paragraphs": [
          "A mismatch on invented reviews is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare reviews a tool made up. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "A written answer can have the wrong hours, April 24, 2023",
        "href": "/blog/blurb-can-be-wrong-2023-04-24"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "memorial-hours-2023-2023-05-29",
    "title": "Mark Memorial Day on the listing, May 29, 2023",
    "seoTitle": "Memorial Day hours (restaurant, May 29, 2023)",
    "description": "Memorial Day hours for a restaurant on May 29, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-05-29",
    "cta": "This week, look at Memorial Day hours. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Memorial Day 2023 is a Monday. If you are closed, the weekly Monday hours will still look open unless you add a special hour.",
          "This May 29, 2023 note is for a restaurant. The check is Memorial Day hours: Memorial Day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Memorial Day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Memorial Day hours. In May 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Memorial Day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Memorial Day hours before you add anything",
        "paragraphs": [
          "A mismatch on Memorial Day hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare Memorial Day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Adjust hours as school schedules change, May 15, 2023",
        "href": "/blog/school-year-ending-2023-05-15"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "kids-out-hours-2023-06-05",
    "title": "Change hours if summer days run differently, June 5, 2023",
    "seoTitle": "Summer daily hours (law office, June 5, 2023)",
    "description": "Summer daily hours for a law office on June 5, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-06-05",
    "cta": "This week, look at hours now that school is out. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Earlier lunches, later jobs, a different rush. Put the pattern you are living on the listing.",
          "This June 5, 2023 note is for a law office. The check is summer daily hours: hours now that school is out, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at hours now that school is out",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at hours now that school is out. In June 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Hours now that school is out on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix hours now that school is out before you add anything",
        "paragraphs": [
          "A mismatch on summer daily hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare hours now that school is out. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Mark Memorial Day on the listing, May 29, 2023",
        "href": "/blog/memorial-hours-2023-2023-05-29"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "father-hours-2023-2023-06-12",
    "title": "Set Father's Day week hours and capacity, June 12, 2023",
    "seoTitle": "Father's Day hours (retail shop, June 12, 2023)",
    "description": "Father's Day hours for a retail shop on June 12, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-06-12",
    "cta": "This week, look at Father's Day week. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If Father's Day 2023 changes the book or the menu, put the hours and the limit on the listing. Take it down the next week.",
          "This June 12, 2023 note is for a retail shop. The check is Father's Day hours: Father's Day week, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Father's Day week",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Father's Day week. In June 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Father's Day week on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Father's Day week before you add anything",
        "paragraphs": [
          "A mismatch on Father's Day hours is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare Father's Day week. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Change hours if summer days run differently, June 5, 2023",
        "href": "/blog/kids-out-hours-2023-06-05"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "draft-invents-prices-2023-06-19",
    "title": "Do not let a draft invent prices, June 19, 2023",
    "seoTitle": "Invented prices (contractor, June 19, 2023)",
    "description": "Invented prices for a contractor on June 19, 2023. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2023-06-19",
    "cta": "This week, look at a price a tool guessed. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Put the price you actually quote, or say the price comes after a look. A made-up number will be the one people repeat.",
          "This June 19, 2023 note is for a contractor. The check is invented prices: a price a tool guessed, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a price a tool guessed",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a price a tool guessed. In June 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A price a tool guessed on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a price a tool guessed before you add anything",
        "paragraphs": [
          "A mismatch on invented prices is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare a price a tool guessed. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Do not let a draft invent reviews, May 22, 2023",
        "href": "/blog/draft-invents-reviews-2023-05-22"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "june-menu-2023-06-26",
    "title": "Publish the June menu or service list as text, June 26, 2023",
    "seoTitle": "June menu (salon, June 26, 2023)",
    "description": "June menu for a salon on June 26, 2023. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2023-06-26",
    "cta": "This week, look at this month's list. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A photo of a printed menu from May will be wrong, and a phone cannot read it. Type the current list.",
          "This June 26, 2023 note is for a salon. The check is June menu: this month's list, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at this month's list",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at this month's list. In June 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "This month's list on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix this month's list before you add anything",
        "paragraphs": [
          "A mismatch on June menu is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare this month's list. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Switch the menu or service list for the season, April 25, 2022",
        "href": "/blog/april-menu-switch-2022-04-25"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "july4-hours-2023-2023-07-03",
    "title": "Write July 4 hours before the weekend, July 3, 2023",
    "seoTitle": "July 4 hours (clinic, July 3, 2023)",
    "description": "July 4 hours for a clinic on July 3, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-07-03",
    "cta": "This week, look at July 4 hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Set July 4, 2023 as a special hour if you close or shorten the day. Do it before the weekend, not after the first wrong visit.",
          "This July 3, 2023 note is for a clinic. The check is July 4 hours: July 4 hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at July 4 hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at July 4 hours. In July 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "July 4 hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix July 4 hours before you add anything",
        "paragraphs": [
          "A mismatch on July 4 hours is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare July 4 hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set Father's Day week hours and capacity, June 12, 2023",
        "href": "/blog/father-hours-2023-2023-06-12"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "universal-analytics-stopped-2023-2023-07-10",
    "title": "The old analytics property stopped taking visits, July 10, 2023",
    "seoTitle": "Universal Analytics shutdown (restaurant, July 10, 2023)",
    "description": "Universal Analytics shutdown for a restaurant on July 10, 2023. What to check so the website and Google listing agree.",
    "section": "Site speed",
    "date": "2023-07-10",
    "cta": "This week, look at the analytics report you still open. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Universal Analytics stopped processing new visits on July 1, 2023. If a number is part of how you run the week, open the property that is still collecting. The listing and the phone number are still the things customers see.",
          "This July 10, 2023 note is for a restaurant. The check is Universal Analytics shutdown: the analytics report you still open, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the analytics report you still open",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the analytics report you still open. In July 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The analytics report you still open on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the analytics report you still open before you add anything",
        "paragraphs": [
          "A mismatch on Universal Analytics shutdown is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare the analytics report you still open. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Know which analytics number you trust, March 14, 2022",
        "href": "/blog/know-which-analytics-2022-2022-03-14"
      },
      {
        "title": "Core Web Vitals for a Local Service Business",
        "href": "/blog/core-web-vitals-for-a-local-service-business"
      }
    ]
  },
  {
    "slug": "staff-recognize-sentences-2023-07-17",
    "title": "The staff should recognize the sentences on the site, July 17, 2023",
    "seoTitle": "Staff review of website copy (law office, July 17, 2023)",
    "description": "Staff review of website copy for a law office on July 17, 2023. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2023-07-17",
    "cta": "This week, look at whether staff recognize the page. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Hand them the page. If they say 'we do not say it that way,' change the page.",
          "This July 17, 2023 note is for a law office. The check is staff review of website copy: whether staff recognize the page, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at whether staff recognize the page",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at whether staff recognize the page. In July 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Whether staff recognize the page on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix whether staff recognize the page before you add anything",
        "paragraphs": [
          "A mismatch on staff review of website copy is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare whether staff recognize the page. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Do not let a draft invent prices, June 19, 2023",
        "href": "/blog/draft-invents-prices-2023-06-19"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "booking-during-vacation-2023-07-24",
    "title": "Block vacation days on the public calendar, July 24, 2023",
    "seoTitle": "Blocked vacation days (retail shop, July 24, 2023)",
    "description": "Blocked vacation days for a retail shop on July 24, 2023. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2023-07-24",
    "cta": "This week, look at days the calendar still shows as open. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If the book-online link still offers a day you are gone, that is the day people will pick.",
          "This July 24, 2023 note is for a retail shop. The check is blocked vacation days: days the calendar still shows as open, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at days the calendar still shows as open",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at days the calendar still shows as open. In July 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Days the calendar still shows as open on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix days the calendar still shows as open before you add anything",
        "paragraphs": [
          "A mismatch on blocked vacation days is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare days the calendar still shows as open. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Name the seasonal work you are actually booking, April 10, 2023",
        "href": "/blog/seasonal-work-you-are-booking-2023-04-10"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "outdoor-delay-2023-07-31",
    "title": "Say how you notify people when outdoor work slips, July 31, 2023",
    "seoTitle": "Outdoor work delay (contractor, July 31, 2023)",
    "description": "Outdoor work delay for a contractor on July 31, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-07-31",
    "cta": "This week, look at how you send a delay. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Text, call, or a listing post. Pick one and do it before they are in the driveway.",
          "This July 31, 2023 note is for a contractor. The check is outdoor work delay: how you send a delay, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at how you send a delay",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at how you send a delay. In July 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "How you send a delay on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix how you send a delay before you add anything",
        "paragraphs": [
          "A mismatch on outdoor work delay is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare how you send a delay. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write July 4 hours before the weekend, July 3, 2023",
        "href": "/blog/july4-hours-2023-2023-07-03"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "prepare-fall-hours-2023-08-07",
    "title": "Draft fall hours before the first fall week, August 7, 2023",
    "seoTitle": "Fall hours (salon, August 7, 2023)",
    "description": "Fall hours for a salon on August 7, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-08-07",
    "cta": "This week, look at the hours you will keep in the fall. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Write them down and put them on the listing the week they start, not after a week of wrong calls.",
          "This August 7, 2023 note is for a salon. The check is fall hours: the hours you will keep in the fall, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the hours you will keep in the fall",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the hours you will keep in the fall. In August 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The hours you will keep in the fall on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the hours you will keep in the fall before you add anything",
        "paragraphs": [
          "A mismatch on fall hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare the hours you will keep in the fall. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Say how you notify people when outdoor work slips, July 31, 2023",
        "href": "/blog/outdoor-delay-2023-07-31"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "school-hours-2023-2023-08-14",
    "title": "Publish back-to-school hours the week they start, August 14, 2023",
    "seoTitle": "Back-to-school hours (clinic, August 14, 2023)",
    "description": "Back-to-school hours for a clinic on August 14, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-08-14",
    "cta": "This week, look at back-to-school hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "School schedules in 2023 change the rush hour. Write the hours you will keep once classes start, on the listing and the page.",
          "This August 14, 2023 note is for a clinic. The check is back-to-school hours: back-to-school hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at back-to-school hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at back-to-school hours. In August 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Back-to-school hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix back-to-school hours before you add anything",
        "paragraphs": [
          "A mismatch on back-to-school hours is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare back-to-school hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Draft fall hours before the first fall week, August 7, 2023",
        "href": "/blog/prepare-fall-hours-2023-08-07"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "one-page-edited-2023-08-21",
    "title": "Edit one page instead of generating ten, August 21, 2023",
    "seoTitle": "Editing one service page (restaurant, August 21, 2023)",
    "description": "Editing one service page for a restaurant on August 21, 2023. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2023-08-21",
    "cta": "This week, look at one finished page. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A single accurate service page is worth more than a stack of drafts you have not read.",
          "This August 21, 2023 note is for a restaurant. The check is editing one service page: one finished page, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at one finished page",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at one finished page. In August 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "One finished page on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix one finished page before you add anything",
        "paragraphs": [
          "A mismatch on editing one service page is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare one finished page. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "The staff should recognize the sentences on the site, July 17, 2023",
        "href": "/blog/staff-recognize-sentences-2023-07-17"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "august-form-2023-08-28",
    "title": "Test the form during the late-summer week, August 28, 2023",
    "seoTitle": "August form test (law office, August 28, 2023)",
    "description": "August form test for a law office on August 28, 2023. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2023-08-28",
    "cta": "This week, look at a form test this week. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Send one message. Late summer inboxes get ignored. Know where the mail lands.",
          "This August 28, 2023 note is for a law office. The check is August form test: a form test this week, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a form test this week",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a form test this week. In August 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A form test this week on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a form test this week before you add anything",
        "paragraphs": [
          "A mismatch on August form test is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare a form test this week. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Send a test message after the break, January 16, 2023",
        "href": "/blog/form-after-the-break-2023-01-16"
      },
      {
        "title": "What to Connect on a Professional Firm's Website",
        "href": "/blog/what-to-connect-on-a-professional-firm-website"
      }
    ]
  },
  {
    "slug": "labor-hours-2023-2023-09-04",
    "title": "Mark Labor Day closed if the door will be locked, September 4, 2023",
    "seoTitle": "Labor Day hours (retail shop, September 4, 2023)",
    "description": "Labor Day hours for a retail shop on September 4, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-09-04",
    "cta": "This week, look at Labor Day hours. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Labor Day 2023 is a Monday. Add the special hour. A description that mentions the holiday is not a substitute.",
          "This September 4, 2023 note is for a retail shop. The check is Labor Day hours: Labor Day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Labor Day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Labor Day hours. In September 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Labor Day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Labor Day hours before you add anything",
        "paragraphs": [
          "A mismatch on Labor Day hours is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare Labor Day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish back-to-school hours the week they start, August 14, 2023",
        "href": "/blog/school-hours-2023-2023-08-14"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "cooler-weather-work-2023-09-11",
    "title": "Name the job that starts when the weather cools, September 11, 2023",
    "seoTitle": "Cool-weather service (contractor, September 11, 2023)",
    "description": "Cool-weather service for a contractor on September 11, 2023. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2023-09-11",
    "cta": "This week, look at the job cooler weather brings. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Put that service in the first screen if it is what you want to be called for. Leave it off if you are already booked out.",
          "This September 11, 2023 note is for a contractor. The check is cool-weather service: the job cooler weather brings, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the job cooler weather brings",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the job cooler weather brings. In September 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The job cooler weather brings on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the job cooler weather brings before you add anything",
        "paragraphs": [
          "A mismatch on cool-weather service is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare the job cooler weather brings. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Block vacation days on the public calendar, July 24, 2023",
        "href": "/blog/booking-during-vacation-2023-07-24"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "listing-description-is-yours-2023-09-18",
    "title": "You still write the listing description, September 18, 2023",
    "seoTitle": "Google Business Profile description (salon, September 18, 2023)",
    "description": "Google Business Profile description for a salon on September 18, 2023. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2023-09-18",
    "cta": "This week, look at the description on the profile. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A tool can suggest a sentence. You have to check that it names the real work and no extra cities.",
          "This September 18, 2023 note is for a salon. The check is Google Business Profile description: the description on the profile, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the description on the profile",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the description on the profile. In September 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The description on the profile on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the description on the profile before you add anything",
        "paragraphs": [
          "A mismatch on Google Business Profile description is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare the description on the profile. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Edit one page instead of generating ten, August 21, 2023",
        "href": "/blog/one-page-edited-2023-08-21"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "september-prices-2023-09-25",
    "title": "Align September prices with the quote, September 25, 2023",
    "seoTitle": "September prices (clinic, September 25, 2023)",
    "description": "September prices for a clinic on September 25, 2023. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2023-09-25",
    "cta": "This week, look at the price on the page. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If the seasonal price changed, change the page the same day. The listing description should not contradict it.",
          "This September 25, 2023 note is for a clinic. The check is September prices: the price on the page, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the price on the page",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the price on the page. In September 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The price on the page on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the price on the page before you add anything",
        "paragraphs": [
          "A mismatch on September prices is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare the price on the page. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Name the job that starts when the weather cools, September 11, 2023",
        "href": "/blog/cooler-weather-work-2023-09-11"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "october-offer-2023-10-02",
    "title": "Date the October offer, October 2, 2023",
    "seoTitle": "October promotion (restaurant, October 2, 2023)",
    "description": "October promotion for a restaurant on October 2, 2023. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2023-10-02",
    "cta": "This week, look at an offer with an end date. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "An offer without an end becomes litter. Name the last day in the same sentence.",
          "This October 2, 2023 note is for a restaurant. The check is October promotion: an offer with an end date, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at an offer with an end date",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at an offer with an end date. In October 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "An offer with an end date on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix an offer with an end date before you add anything",
        "paragraphs": [
          "A mismatch on October promotion is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare an offer with an end date. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Align September prices with the quote, September 25, 2023",
        "href": "/blog/september-prices-2023-09-25"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "trick-or-treat-hours-2023-10-09",
    "title": "Say whether the door is open for the evening crowd, October 9, 2023",
    "seoTitle": "Evening hours on Halloween (law office, October 9, 2023)",
    "description": "Evening hours on Halloween for a law office on October 9, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-10-09",
    "cta": "This week, look at whether you are open that evening. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Retail and restaurants get this question. Answer it on the listing, including a close time.",
          "This October 9, 2023 note is for a law office. The check is evening hours on Halloween: whether you are open that evening, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at whether you are open that evening",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at whether you are open that evening. In October 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Whether you are open that evening on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix whether you are open that evening before you add anything",
        "paragraphs": [
          "A mismatch on evening hours on Halloween is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare whether you are open that evening. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Mark Labor Day closed if the door will be locked, September 4, 2023",
        "href": "/blog/labor-hours-2023-2023-09-04"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "draft-does-not-answer-phone-2023-10-16",
    "title": "A draft does not answer the phone, October 16, 2023",
    "seoTitle": "Phone coverage (retail shop, October 16, 2023)",
    "description": "Phone coverage for a retail shop on October 16, 2023. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2023-10-16",
    "cta": "This week, look at who answers the phone. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The page can be polished and the call can still go nowhere. The person answering is the system that matters.",
          "This October 16, 2023 note is for a retail shop. The check is phone coverage: who answers the phone, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at who answers the phone",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at who answers the phone. In October 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Who answers the phone on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix who answers the phone before you add anything",
        "paragraphs": [
          "A mismatch on phone coverage is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare who answers the phone. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "You still write the listing description, September 18, 2023",
        "href": "/blog/listing-description-is-yours-2023-09-18"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "october-popup-2023-10-23",
    "title": "Remove a graphic that covers the number, October 23, 2023",
    "seoTitle": "Graphic covering the phone number (contractor, October 23, 2023)",
    "description": "Graphic covering the phone number for a contractor on October 23, 2023. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2023-10-23",
    "cta": "This week, look at a graphic on top of the number. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A seasonal illustration is optional. The number is not. If they overlap, move the art.",
          "This October 23, 2023 note is for a contractor. The check is graphic covering the phone number: a graphic on top of the number, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a graphic on top of the number",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a graphic on top of the number. In October 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A graphic on top of the number on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a graphic on top of the number before you add anything",
        "paragraphs": [
          "A mismatch on graphic covering the phone number is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare a graphic on top of the number. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Date the October offer, October 2, 2023",
        "href": "/blog/october-offer-2023-10-02"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "halloween-hours-2023-2023-10-30",
    "title": "Publish Halloween day hours, October 30, 2023",
    "seoTitle": "Halloween hours (salon, October 30, 2023)",
    "description": "Halloween hours for a salon on October 30, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-10-30",
    "cta": "This week, look at Halloween day hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Halloween 2023 often means an earlier close or a later door. Write the day itself, not a vague seasonal note.",
          "This October 30, 2023 note is for a salon. The check is Halloween hours: Halloween day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Halloween day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Halloween day hours. In October 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Halloween day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Halloween day hours before you add anything",
        "paragraphs": [
          "A mismatch on Halloween hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare Halloween day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Say whether the door is open for the evening crowd, October 9, 2023",
        "href": "/blog/trick-or-treat-hours-2023-10-09"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "veterans-hours-2023-2023-11-06",
    "title": "Set Veterans Day hours if you close, November 6, 2023",
    "seoTitle": "Veterans Day hours (clinic, November 6, 2023)",
    "description": "Veterans Day hours for a clinic on November 6, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-11-06",
    "cta": "This week, look at Veterans Day hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you close or shorten Veterans Day 2023, write that day on the listing. The weekly schedule does not know the holiday.",
          "This November 6, 2023 note is for a clinic. The check is Veterans Day hours: Veterans Day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Veterans Day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Veterans Day hours. In November 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Veterans Day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Veterans Day hours before you add anything",
        "paragraphs": [
          "A mismatch on Veterans Day hours is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare Veterans Day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish Halloween day hours, October 30, 2023",
        "href": "/blog/halloween-hours-2023-2023-10-30"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "do-not-publish-unread-2023-11-13",
    "title": "Do not publish a page you have not read, November 13, 2023",
    "seoTitle": "Unpublished draft review (restaurant, November 13, 2023)",
    "description": "Unpublished draft review for a restaurant on November 13, 2023. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2023-11-13",
    "cta": "This week, look at a page you have not read. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Read it on a phone first. If you would not hand it to a customer, it is not ready.",
          "This November 13, 2023 note is for a restaurant. The check is unpublished draft review: a page you have not read, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a page you have not read",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a page you have not read. In November 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A page you have not read on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a page you have not read before you add anything",
        "paragraphs": [
          "A mismatch on unpublished draft review is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare a page you have not read. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "A draft does not answer the phone, October 16, 2023",
        "href": "/blog/draft-does-not-answer-phone-2023-10-16"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "thanksgiving-hours-2023-2023-11-20",
    "title": "Write Thanksgiving week hours before Monday, November 20, 2023",
    "seoTitle": "Thanksgiving hours (law office, November 20, 2023)",
    "description": "Thanksgiving hours for a law office on November 20, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-11-20",
    "cta": "This week, look at Thanksgiving week hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Put Thanksgiving 2023 on special hours in Google Business Profile, and mirror them on the contact page.",
          "This November 20, 2023 note is for a law office. The check is Thanksgiving hours: Thanksgiving week hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Thanksgiving week hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Thanksgiving week hours. In November 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Thanksgiving week hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Thanksgiving week hours before you add anything",
        "paragraphs": [
          "A mismatch on Thanksgiving hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare Thanksgiving week hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set Veterans Day hours if you close, November 6, 2023",
        "href": "/blog/veterans-hours-2023-2023-11-06"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "holiday-calendar-2023-11-27",
    "title": "Open the holiday booking calendar, November 27, 2023",
    "seoTitle": "Holiday booking calendar (retail shop, November 27, 2023)",
    "description": "Holiday booking calendar for a retail shop on November 27, 2023. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2023-11-27",
    "cta": "This week, look at dates people can still book. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Blocked days should look blocked. An open slot on a day you are closed will get picked.",
          "This November 27, 2023 note is for a retail shop. The check is holiday booking calendar: dates people can still book, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at dates people can still book",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at dates people can still book. In November 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Dates people can still book on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix dates people can still book before you add anything",
        "paragraphs": [
          "A mismatch on holiday booking calendar is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare dates people can still book. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Remove a graphic that covers the number, October 23, 2023",
        "href": "/blog/october-popup-2023-10-23"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "christmas-eve-versus-day-2023-12-04",
    "title": "Separate Christmas Eve from Christmas Day, December 4, 2023",
    "seoTitle": "Christmas Eve hours (contractor, December 4, 2023)",
    "description": "Christmas Eve hours for a contractor on December 4, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-12-04",
    "cta": "This week, look at Christmas Eve versus Christmas Day. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "They are different days and often different hours. Special hours can say both. One note that says 'closed for Christmas' is too vague.",
          "This December 4, 2023 note is for a contractor. The check is Christmas Eve hours: Christmas Eve versus Christmas Day, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Christmas Eve versus Christmas Day",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Christmas Eve versus Christmas Day. In December 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Christmas Eve versus Christmas Day on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Christmas Eve versus Christmas Day before you add anything",
        "paragraphs": [
          "A mismatch on Christmas Eve hours is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare Christmas Eve versus Christmas Day. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write Thanksgiving week hours before Monday, November 20, 2023",
        "href": "/blog/thanksgiving-hours-2023-2023-11-20"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "keep-the-old-page-until-2023-12-11",
    "title": "Keep the current page up while you edit, December 11, 2023",
    "seoTitle": "Editing without taking the site down (salon, December 11, 2023)",
    "description": "Editing without taking the site down for a salon on December 11, 2023. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2023-12-11",
    "cta": "This week, look at the live page while you edit. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Do not replace a clear page with a draft in one move. Fix the sentences, then publish.",
          "This December 11, 2023 note is for a salon. The check is editing without taking the site down: the live page while you edit, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the live page while you edit",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the live page while you edit. In December 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The live page while you edit on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the live page while you edit before you add anything",
        "paragraphs": [
          "A mismatch on editing without taking the site down is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare the live page while you edit. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Do not publish a page you have not read, November 13, 2023",
        "href": "/blog/do-not-publish-unread-2023-11-13"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "new-years-eve-hours-2023-12-18",
    "title": "Set New Year's Eve hours on their own, December 18, 2023",
    "seoTitle": "New Year's Eve hours (clinic, December 18, 2023)",
    "description": "New Year's Eve hours for a clinic on December 18, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-12-18",
    "cta": "This week, look at New Year's Eve. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you close early or take reservations only, write that. A normal Tuesday schedule is the wrong information.",
          "This December 18, 2023 note is for a clinic. The check is New Year's Eve hours: New Year's Eve, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at New Year's Eve",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at New Year's Eve. In December 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "New Year's Eve on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix New Year's Eve before you add anything",
        "paragraphs": [
          "A mismatch on New Year's Eve hours is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare New Year's Eve. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Separate Christmas Eve from Christmas Day, December 4, 2023",
        "href": "/blog/christmas-eve-versus-day-2023-12-04"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "christmas-hours-2023-2023-12-25",
    "title": "Separate Christmas Eve, Christmas Day, and the days after, December 25, 2023",
    "seoTitle": "Christmas hours (restaurant, December 25, 2023)",
    "description": "Christmas hours for a restaurant on December 25, 2023. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2023-12-25",
    "cta": "This week, look at Christmas week hours. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Write Christmas Eve, Christmas Day, and the day you reopen for 2023. One line that says \"closed for the holidays\" is not a schedule.",
          "This December 25, 2023 note is for a restaurant. The check is Christmas hours: Christmas week hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Christmas week hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Christmas week hours. In December 2023 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Christmas week hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Christmas week hours before you add anything",
        "paragraphs": [
          "A mismatch on Christmas hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare Christmas week hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2023 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set New Year's Eve hours on their own, December 18, 2023",
        "href": "/blog/new-years-eve-hours-2023-12-18"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  }
];
